// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

import Navbar                 from "./components/Navbar";
import Footer                 from "./components/Footer";
import { VideoPopupProvider } from "./components/VideoPopupContext";
import { BrandProvider }      from "./brand/BrandContext";
import { AuthProvider }       from "./auth/AuthContext";

import Home           from "./pages/Home";
import CityWatch      from "./pages/CityWatch";
import About          from "./pages/About";
import DistrictPage   from "./pages/DistrictPage";
import LoginPage      from "./pages/LoginPage";
import PrivacyPolicy  from "./pages/PrivacyPolicy";
import Contact        from "./pages/Contact";
import Terms          from "./pages/Terms";
import Patents        from "./pages/Patents";
import MinnesotaPartnership from "./pages/MinnesotaPartnership";

function App() {
  return (
    <VideoPopupProvider>
      <Router>
        <AuthProvider>
        <BrandProvider>
        <ScrollToTop />

        <Routes>
          {/* 1. WIDGET ROUTE (Isolated - No Nav/Footer) */}
          <Route 
            path="/embed/districts/:abbreviation" 
            element={<DistrictPage isWidget={true} />} 
          />

          {/* 2. DISTRICT DASHBOARD (Has Navbar, No Footer) */}
          <Route 
            path="/districts/:abbreviation" 
            element={
              <>
                <Navbar />
                <div className="navbar-space" />
                <DistrictPage isWidget={false} />
              </>
            } 
          />

          {/* 3. MAIN SITE ROUTES (Has Navbar AND Footer) */}
          <Route
            path="*"
            element={
              <>
                <Navbar />
                <div className="navbar-space" />
                <Routes>
                  <Route path="/"              element={<Home />} />
                  <Route path="/city-watch"    element={<CityWatch />} />
                  <Route path="/about"         element={<About />} />
                  <Route path="/contactus"     element={<Contact />} />
                  <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                  <Route path="/terms"         element={<Terms />} />
                  <Route path="/patents"       element={<Patents />} />
                  <Route path="/login"         element={<LoginPage />} />
                  <Route path="/minnesota"     element={<MinnesotaPartnership />} />
                </Routes>
                <Footer />
              </>
            }
          />
        </Routes>
        </BrandProvider>
        </AuthProvider>
      </Router>
    </VideoPopupProvider>
  );
}

export default App;